import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "outer"
}
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = {
  key: 1,
  class: "description"
}
const _hoisted_4 = {
  key: 1,
  class: "shared-by"
}
const _hoisted_5 = { class: "section-title" }
const _hoisted_6 = { class: "top-field" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = {
  key: 2,
  class: "people"
}
const _hoisted_9 = { class: "section-title" }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { class: "section-title" }
const _hoisted_12 = { class: "section-title" }
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = { class: "text" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "title" }
const _hoisted_17 = {
  key: 1,
  class: "title"
}
const _hoisted_18 = { class: "subtitle" }
const _hoisted_19 = {
  key: 0,
  class: "edit"
}
const _hoisted_20 = {
  key: 4,
  class: "map"
}
const _hoisted_21 = {
  key: 1,
  class: "loading-icon fill-block"
}
const _hoisted_22 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcAvatar = _resolveComponent("NcAvatar")!
  const _component_Cluster = _resolveComponent("Cluster")!
  const _component_AlbumsList = _resolveComponent("AlbumsList")!
  const _component_EditIcon = _resolveComponent("EditIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_NcActions = _resolveComponent("NcActions")!
  const _component_MapStandalone = _resolveComponent("MapStandalone")!
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!

  return (_ctx.fileid)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.title || _ctx.description)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "exif-head",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editEXIF()))
            }, [
              (_ctx.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
                : _createCommentVNode("", true),
              (_ctx.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.description), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isShared)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('memories', 'Shared By')), 1),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_NcAvatar, {
                  key: "uid",
                  user: _ctx.baseInfo.owneruid,
                  showUserStatus: false,
                  size: 24
                }, null, 8, ["user"]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.baseInfo.ownername), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.people.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t('memories', 'People')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.people, (face) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "container",
                  key: face.cluster_id
                }, [
                  _createVNode(_component_Cluster, {
                    class: "cluster--rounded",
                    data: face,
                    counters: false
                  }, null, 8, ["data"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.albums.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t('memories', 'Albums')), 1),
              _createVNode(_component_AlbumsList, {
                class: "albums",
                albums: _ctx.albums
              }, null, 8, ["albums"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('memories', 'Metadata')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topFields, (field) => {
          return (_openBlock(), _createElementBlock("div", {
            key: field.title,
            class: _normalizeClass(`top-field top-field--${field.id}`)
          }, [
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(field.icon), { size: 24 }))
            ]),
            _createElementVNode("div", _hoisted_14, [
              (field.href)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: field.href,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(field.title), 1)
                  ], 8, _hoisted_15))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(field.title), 1)),
              (field.subtitle.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("span", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.subtitle, (part) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "part",
                          key: part
                        }, _toDisplayString(part), 1))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (_ctx.canEdit && field.edit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_NcActions, { inline: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NcActionButton, {
                        "aria-label": _ctx.t('memories', 'Edit'),
                        onClick: ($event: any) => (field.edit?.())
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_EditIcon, { size: 20 })
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Edit')) + " ", 1)
                        ]),
                        _: 1
                      }, 8, ["aria-label", "onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true)
          ], 2))
        }), 128)),
        (_ctx.lat && _ctx.lon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_MapStandalone, {
                center: [_ctx.lat, _ctx.lon],
                pins: [[_ctx.lat, _ctx.lon]]
              }, null, 8, ["center", "pins"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_XLoadingIcon)
        ]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.t('memories', 'Failed to load metadata')), 1))
        : _createCommentVNode("", true)
}